var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'toast',
    { 'toast--show': _vm.active === true },
    { 'toast--hide': _vm.active === false },
    _vm.type ]},[(_vm.type === 'error')?_c('DelSVG'):_vm._e(),(_vm.type === 'success')?_c('DoneSVG'):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.msg))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }